import { Box } from '@chakra-ui/react';

interface IProps {
  isIncomplete?: boolean;
}

export const CompleteIcon = (props: IProps) => {
  const { isIncomplete } = props;

  let colorScheme;
  let emoji;

  if (isIncomplete) {
    colorScheme = 'orange';
    emoji = '🤔';
  } else {
    colorScheme = 'teal';
    emoji = '🥳';
  }

  return (
    <Box
      my={8}
      mx="auto"
      width={32}
      height={32}
      borderRadius="full"
      fontSize="6xl"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bgColor={`${colorScheme}.100`}
      color={`${colorScheme}.400`}
      _dark={{
        bgColor: `${colorScheme}.800`,
      }}
    >
      {emoji}
    </Box>
  );
};
